export enum WebInterface {
  WEEKLY_PILOTING = 'WEEKLY_PILOTING',
  COMPARISON_PILOTING = 'COMPARISON_PILOTING',
  ANNUAL_INIT_PILOTING = 'ANNUAL_INIT_PILOTING',
  GROUP_SPORT_PILOTING = 'GROUP_SPORT_PILOTING',
  STORE_MONTHLY_PILOTING = 'STORE_MONTHLY_PILOTING',
  DAY_DAY_PILOTING = 'DAY_DAY_PILOTING'
}
